// extracted by mini-css-extract-plugin
module.exports = {"toggler":"Toggler_toggler__3uamZ","justify-end":"Toggler_justify-end__18ye2","checkbox":"Toggler_checkbox__jV7mX","slider":"Toggler_slider__3vJiS","label":"Toggler_label__1SyoG"};